import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { useCallback } from 'react'
import { useHistory } from 'react-router'
import { useJustificativaVerProntuarioId } from 'view/prontuario/justificativa/useJustificativaVerProntuarioId'
import { REGISTRO_TARDIO_PATH } from 'view/registro-tardio/RegistroTardioRootView'
import { useRetificacaoStorage } from 'view/retificacao-atendimento/useJustificativaRetificacaoStorage'

interface UseAtendimentoCallbackProps {
  cidadaoId: string
  atendimentoId: string
  isRetificacao?: boolean
  isRegistroTardio?: boolean
  onGoToCallbackUrl: () => void
}

export function useAtendimentoCallbackUrl(props: UseAtendimentoCallbackProps) {
  const { cidadaoId, atendimentoId, isRetificacao = false, isRegistroTardio = false, onGoToCallbackUrl } = props

  const history = useHistory()
  const { getRetificacaoStorageValue, deleteStorageRetificacao } = useRetificacaoStorage(atendimentoId)
  const { callbackUrl: retificacaoCallbackUrl, justificativaVerProntuarioId } = getRetificacaoStorageValue()

  const cidadaoBaseUrl = `${CIDADAO_PATH}/${cidadaoId}`
  const [, setJustificativaVerProntuarioId] = useJustificativaVerProntuarioId(cidadaoBaseUrl, cidadaoId)

  const atendimentoCallbackUrl = isRegistroTardio ? REGISTRO_TARDIO_PATH : '/lista-atendimento'
  const callbackUrl = isRetificacao ? retificacaoCallbackUrl : atendimentoCallbackUrl

  const goToCallbackUrl = useCallback(() => {
    justificativaVerProntuarioId && setJustificativaVerProntuarioId(justificativaVerProntuarioId)
    isRetificacao && deleteStorageRetificacao()

    // Necessário setTimeout para só navegar depois de atualizar os storages
    // TODO (RNG) #24441: Criar interface async para os "useStorage"
    onGoToCallbackUrl()
    setTimeout(() => history.push(callbackUrl))
  }, [
    callbackUrl,
    onGoToCallbackUrl,
    deleteStorageRetificacao,
    history,
    isRetificacao,
    justificativaVerProntuarioId,
    setJustificativaVerProntuarioId,
  ])

  return {
    goToCallbackUrl,
  }
}
